import React from "react";

const Parking = () => {
  const parkingSlots = [
    { id: 1, number: "A-01", status: "Available" },
    { id: 2, number: "A-02", status: "Occupied" },
    { id: 3, number: "A-03", status: "Reserved" },
    { id: 4, number: "B-01", status: "Occupied" },
    { id: 5, number: "B-02", status: "Available" },
    { id: 6, number: "B-03", status: "Available" },
  ];

  const statusColors = {
    Available: "bg-green-100 text-green-600",
    Occupied: "bg-red-100 text-red-600",
    Reserved: "bg-yellow-100 text-yellow-600",
  };

  return (
    <div className="p-6">
      <h1 className="text-3xl font-semibold mb-6">Parking Management</h1>

      {/* Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-8">
        <div className="bg-white shadow rounded-xl p-5">
          <h2 className="text-xl font-semibold">Total Slots</h2>
          <p className="text-3xl mt-2 font-bold">30</p>
        </div>
        <div className="bg-white shadow rounded-xl p-5">
          <h2 className="text-xl font-semibold">Available</h2>
          <p className="text-3xl mt-2 font-bold text-green-600">12</p>
        </div>
        <div className="bg-white shadow rounded-xl p-5">
          <h2 className="text-xl font-semibold">Occupied</h2>
          <p className="text-3xl mt-2 font-bold text-red-600">18</p>
        </div>
      </div>
      {/* Parking Slots Grid */}
      <div className="bg-white shadow rounded-xl p-6">
        <h2 className="text-xl font-semibold mb-4">Parking Slots</h2>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {parkingSlots.map((slot) => (
            <div
              key={slot.id}
              className="border rounded-xl p-4 flex flex-col items-center shadow-sm bg-gray-50 hover:shadow-md transition"
            >
              <p className="text-xl font-semibold">{slot.number}</p>
              <span
                className={`mt-2 px-3 py-1 text-sm rounded-full ${statusColors[slot.status]}`}
              >
                {slot.status}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Parking;
